import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment, { duration } from "moment";

import { useUser, usePopup, useData, useMenu, useLang, useLoading } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import * as APIS from '../utils/service.js'

import consts from '../libs/consts';
import images from "../libs/images"
import InputFileDrag from '../components/InputFileDrag';
import Button from '../components/Button';
import Radio from "../components/Radio";
import Modal from "../components/Modal.js";

// 고해상도 영상
export default function Menu8() {
    const navigate = useNavigate();
    const location = useLocation();

    const { menu, getMenu } = useMenu();
    const { country, getLang } = useLang();
    const { bears, token, options, isReload, reload, setData, addABear } = useUser();
    const { open, title, popOpen, popClose } = usePopup();
    const { setLoading } = useLoading();

    const [config, setConifg] = useState({});
    const [configError, setConfigError] = useState(false);
    const [limitSize, setLimitSize] = useState(10000000000)

    const [inputVideo, setInputVideo] = useState(null)
    const [videoError, setVideoError] = useState(false);
    const [videoInfoError, setvideoInfoError] = useState(false);
    const [mediaInfo, setMediaInfo] = useState(null);

    const [radio1, setRadio1] = useState(1);
    const [radio2, setRadio2] = useState(1);
    const [share, setShare] = useState(false);

    const [calcPoint, setCalcPoint] = useState(0);

    const [modal, setModal] = useState(consts.defaultModalValue)

    const makeVideoFunc = () => {
        let sendData = {
            video: inputVideo,
            videoInfo: mediaInfo
        }

        if (!inputVideo) {
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: "error_input_video" })
            })
            return
        }

        sendData.multiple = radio1
        sendData.quality = radio2

        sendData.share = !share
        console.log(sendData)

        // setLoading(true);
        // setTimeout(() => {
        //     setLoading(false);
        // }, 2000)
        // return
        setLoading(true);
        APIS.post("/aiVideo/resolution", sendData).then(({ data }) => {
            if (data) console.log("/aiVideo/resolution:", data);
            setLoading(false);
            reload();
            navigate("/myart_history")
        }).catch((result) => {
            setLoading(false);
            let data = result.response.data;
            setModal({
                ...modal,
                open: true,
                message: getLang({ key: data.msgkey })
            })
        })
    }

    const defaultSetOption = (configData) => {
        let error = false

        if ("option_selector_multiple" in configData) {
            setRadio1(configData.option_selector_multiple[0].idx)
        } else {
            error = true
        }

        if ("option_selector_quality" in configData) {
            setRadio2(configData.option_selector_quality[0].idx)
        } else {
            error = true
        }

        if (error) setConfigError(error)

        if (location.state?.artData) {
            setLoading(true)
            setTimeout(() => {
                setLoading(false)
                setLoadFunc(location.state?.artData, configData)
            }, 1000)
        }
    }

    const setLoadFunc = async (artData, configData) => {
        console.log("다시만들기")
        console.log("🚀 ~ setLoadPrec ~ artData:", artData)


        if (artData?.multipleOption) {
            let data = configData.option_selector_multiple?.find(v => v.value == artData?.multipleOption)
            if (data) {
                setRadio1(data.idx)
            }
        }

        if (artData?.qualityOption) {
            let data = configData.option_selector_quality?.find(v => v.value == artData?.qualityOption)
            if (data) {
                setRadio2(data.idx)
            }
        }

    }

    const configDataFunc = () => {
        APIS.post('/config/option').then(({ data }) => {
            setConifg(data);
            defaultSetOption(data);
        }).catch((e) => {
            console.log(e.response.data);
        });
    }

    const onVidoeMeta = (metaData) => {
        setVideoError(false)
        setvideoInfoError(false);
        console.log(metaData)
        if (metaData) {
            if (metaData?.height > 1080) {
                setVideoError(true)
                setMediaInfo(null)
            } else {
                let point = getMenu({ idx: 8 })?.point
                let result = metaData.width * metaData.height * metaData.duration / point
                console.log("metaData", metaData)

                if (result < 1) {
                    result = 1;
                }

                setMediaInfo(metaData);
                setCalcPoint(Math.floor(Number(result.toFixed(2))));
            }
        } else {
            setVideoError(false);
            setvideoInfoError(true);
            setMediaInfo(null)
        }
    }

    useEffect(() => {
        configDataFunc();
    }, []);


    const modalConfirm = () => {
        if (modal.type === "test") {

        } else {
            modalClose();
        }
    }

    const modalClose = () => {
        setModal(consts.defaultModalValue)
    }

    const videoRef = useRef(null);

    function imageDownFunc() {
        fetch(consts.imgUrl + "/2062f17f-63a8-45b9-94eb-95de7e8ba8a5.mp4", {
            method: "GET",
            headers: {}
        })
            .then(response => {
                response.arrayBuffer().then(function (buffer) {
                    const url = window.URL.createObjectURL(new Blob([buffer]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "download.mp4"); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    return (
        <>

            <Modal
                open={modal.open}
                setOpen={(v) => {
                    setModal({ ...modal, open: v })
                }}
                title={modal.title}
                message={modal.message}
                onConfirm={modalConfirm}
                onCancel={modal.isClose ? () => { modalClose(); } : null}
            />

            <div className="content">
                {/* <input type="file"
                    onChange={({ target: { files } }) => {
                        if (files.length) {
                            let reader = new FileReader();
                            reader.onload = function () {
                                if (videoRef) {
                                    console.log("🚀 ~ Menu8 ~ videoRef:", videoRef)
                                    videoRef.current.src = reader.result;
                                }
                            };
                            reader.readAsDataURL(files[0]);
                        }
                    }} />
                <video ref={videoRef} style={{
                    width: "100%",
                    aspectRatio: 1.6
                }} autoPlay controls/> */}
                {/* <Button title="down" onClick={imageDownFunc} /> */}

                <div className="title_box3">
                    <div className="text_area">
                        <p className="title">
                            <LangText id={getMenu({ idx: 8 }).title_key} />
                        </p>
                        <p className="sub_title">
                            <LangText id={getMenu({ idx: 8 }).info_key} />
                        </p>
                    </div>
                    <div className="thumb">
                        {/* <img src={consts.imgUrl + getMenu({ idx: 8 })?.image?.ko} /> */}
                        <img src={consts.imgUrl + getMenu({ idx: 8 })?.image?.[country]} />
                    </div>
                </div>

                <div className="setting_box">
                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_upload_row_video" /></p>
                                <p className="body1"><LangText id="info_upload_row_video" /></p>
                                {videoError && <p className="body1 color-red"><LangText id="error_bigsize_image" /></p>}
                                {videoInfoError && <p className="body1 color-red"><LangText id="err_videoinfo_error" /></p>}
                            </div>
                        </div>

                        <InputFileDrag
                            name="drag-file"
                            valid="video"
                            limit={limitSize}
                            onMetaData={onVidoeMeta}
                            setValue={(v) => {
                                if (!v) {
                                    setMediaInfo(null);
                                    setCalcPoint(0)
                                }
                                setInputVideo(v)
                            }}
                        />
                    </div>

                    <div className="option_item_box">
                        <div className="menu_title_box">
                            <div className="text_box">
                                <p className="title2"><LangText id="text_option_set" /></p>
                                <p className="body1"><LangText id="info_high_quality_option" /></p>
                            </div>
                        </div>
                        <div className="border_box">
                            <p className="body1 color-black">
                                <LangText id="text_option_resolution" />
                            </p>
                            <Radio
                                className="mt-12"
                                border={false}
                                value={radio1}
                                setValue={setRadio1}
                                options={config?.option_selector_multiple?.map((v) => {
                                    return { label: getLang({ key: v?.title_key }), value: v.idx }
                                })} />
                            <hr className="mt-24" />
                            <p className="body1 mt-24 color-black">
                                <LangText id="text_option_quality" />
                            </p>
                            <Radio
                                className="mt-12"
                                border={false}
                                value={radio2}
                                setValue={setRadio2}
                                options={config?.option_selector_quality?.map((v) => {
                                    return { label: getLang({ key: v?.title_key }), value: v.idx }
                                })} />
                        </div>
                    </div>
                </div>

                <div className="confirm_box mt-80">
                    <Button
                        type={4}
                        title={getLang({ key: "btn_create_video", replace: { key: "{0}", val: calcPoint ? calcPoint : 0 } })}
                        round
                        onClick={makeVideoFunc}
                        // disable={calcPoint ? false : true}
                        disable={(inputVideo && !videoError && !videoInfoError) ? false : true}
                    />
                    <input
                        type="checkbox"
                        id={"checkShare"}
                        className='checkbox5'
                        checked={share}
                        onChange={(e) => {
                            setShare(e.target.checked)
                        }} />
                    <label className="mt-12" for={'checkShare'}>
                        <LangText id="btn_not_share" />
                    </label>
                </div>
            </div>
        </>
    );
}
